import queryString from 'query-string';

export const getInitialSorting = ({ searchParamsString, columnsList }) => {
  const initialOrdersState = [];
  const { ordering } = queryString.parse(searchParamsString);

  if (!ordering) {
    return initialOrdersState;
  }

  const isAscSorting = ordering.startsWith('-');

  const accessorKey = isAscSorting ? ordering.slice(1) : ordering;
  const column = columnsList.find(col => col.accessorKey === accessorKey);

  if (!column) {
    return initialOrdersState;
  }

  initialOrdersState.push({ id: column.id, desc: !isAscSorting });

  return initialOrdersState;
};

const adaptCellToNewTables = oldCell => ctx =>
  oldCell({
    original: ctx.row.original,
    value: ctx.getValue?.(),
    column: ctx.column,
    table: ctx.table,
  });

export const getNewBaseTableColumns = columns =>
  columns.map(({ key, Cell, id, size }) => ({
    headerKey: typeof key === 'string' ? key : null,
    id: id || null,
    cell: Cell ? adaptCellToNewTables(Cell) : undefined,
    size: size || 150,
  }));

export const getNewTableColumns = columns =>
  columns.map(({ Header, Cell, id, accessor, size }) => ({
    headerKey: typeof Header === 'string' ? Header : null,
    id: id || null,
    cell: Cell,
    accessorKey: accessor || null,
    size: size || 150,
  }));
